import PropTypes from 'prop-types';
import React from 'react';
import PieChart from '../../charts/PieChart.jsx';
import DataTable from '../../dataTable.jsx';
import {formatCurrency} from '../../../helpers/dashboardFormatter.jsx';
import {intlShape, injectIntl} from 'react-intl';
import {bindLocaleUpdate} from 'helpers/bindLocaleUpdate';


const darkestColorBased = -0.2; //50% darker;
const lightestColorBased = 0.8; //80% lighter;

/**
 * Create a color darker or lighter based in a hex color .
 * @param  {hex}       a hex color value such as “#abc” or “#123456” (the hash is optional).
 * @param  {lum}    the luminosity factor, i.e. -0.1 is 10% darker, 0.2 is 20% lighter, etc.
 * @return {string}    hex color ligther or darker.
 */

function ColorLuminance(hex, lum) {
  // validate hex string
  hex = String(hex).replace(/[^0-9a-f]/gi, '');
  if (hex.length < 6) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }
  lum = lum || 0;

  // convert to decimal and change luminosity
  var rgb = '#', c, i;

  for (i = 0; i < 3; i++) {
    c = parseInt(hex.substr(i * 2, 2), 16);
    c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
    rgb += ('00' + c).substr(c.length);
  }

  return rgb;
}

const BioguardProductSales = ({
                                categoryName,
                                totalProductSalesAmount,
                                baseColor,
                                productSalesDetails,
                                positionArrow,
                                intl,
                              }) => {
  let headerRow = ['Product', 'Sales ($)'];
  let initialColorDegradation = lightestColorBased;

  productSalesDetails = productSalesDetails.map((productDetail, index) => {
    let degradationLevel = initialColorDegradation - index / 7;
    let productColor = ColorLuminance(baseColor, degradationLevel);

    return Object.assign({}, productDetail, {
      color: productColor,
      styledColorReferenceBox: {
        backgroundColor: productColor,
        width: 20,
        height: 20,
        display: 'inline-block',
        marginRight: 6,
      },
    });
  });

  let dataRows = (productSalesDetails || []).map(row => [
    <div key='productname' className='tc'><i style={row.styledColorReferenceBox}/>{row.productName}</div>,
    <div key='sales' className='tc'>{formatCurrency(row.sales)}</div>,
  ]);

  let arrowPosition = {
    left: `${positionArrow}px`,
  };

  return <div>
    {positionArrow && positionArrow !== 0 ? <span className='arrow'
                                                  style={arrowPosition}/> : <span/>}
    <div className="product-sales-chart-report">
      <div className='row'>
        <div className='col-sm-6 product-sales-info'>
          <div className="product-sales-header">
            <h6>{categoryName}</h6>
            <div className="product-sales-subheader">
              {formatCurrency(totalProductSalesAmount)}
            </div>
          </div>
          <div className='table-biolab table-dashboard'>
            <DataTable headerRow={headerRow}
                       data={dataRows}/>
          </div>
        </div>
        <div className='col-sm-6'>
          <PieChart height={300}
                    innerRadius={'50%'}
                    balloonText={'[[title]]  ' + intl.formatMessage({id: 'general.sales'}) + ' <b>$[[value]]</b> ([[percents]]%)'}
                    data={productSalesDetails && productSalesDetails.length > 0 ? productSalesDetails.map(p => ({
                      name: p.productName,
                      value: p.sales,
                      color: p.color,
                    })
                    ) : []}
          />
        </div>
      </div>
    </div>
  </div>;
};

BioguardProductSales.propTypes = {
  categoryName: PropTypes.string.isRequired,
  totalProductSalesAmount: PropTypes.number.isRequired,
  baseColor: PropTypes.string.isRequired,
  productSalesDetails: PropTypes.array.isRequired,
  positionArrow: PropTypes.number,
  intl: intlShape.isRequired,
};

export default injectIntl(bindLocaleUpdate(BioguardProductSales));
